import React from "react";

const Welcome = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "calc(100vh - 200px)",
        fontSize: 24,
        color: "rgba(0,0,0,0.85)",
      }}
    >
      欢迎使用友电之星管理后台
    </div>
  );
};

export default Welcome;
